import { Currency } from '../../../../../../types/generatedTypes';

export interface CurrencyData {
  code: Currency;
  symbol: string;
}

export const CURRENCIES: CurrencyData[] = [
  { code: 'AED', symbol: 'د.إ' },
  { code: 'ARS', symbol: '$' },
  { code: 'AUD', symbol: '$' },
  { code: 'BRL', symbol: 'R$' },
  { code: 'CAD', symbol: '$' },
  { code: 'CHF', symbol: 'CHF' },
  { code: 'CLP', symbol: '$' },
  { code: 'CNH', symbol: '¥' },
  { code: 'CNY', symbol: '¥' },
  { code: 'CZK', symbol: 'Kč' },
  { code: 'DKK', symbol: 'kr' },
  { code: 'EGP', symbol: '£' },
  { code: 'EUR', symbol: '€' },
  { code: 'GBP', symbol: '£' },
  { code: 'HKD', symbol: '$' },
  { code: 'HUF', symbol: 'Ft' },
  { code: 'IDR', symbol: 'Rp' },
  { code: 'ILS', symbol: '₪' },
  { code: 'INR', symbol: '₹' },
  { code: 'ISK', symbol: 'kr' },
  { code: 'JOD', symbol: 'د.ا' },
  { code: 'JPY', symbol: '¥' },
  { code: 'KRW', symbol: '₩' },
  { code: 'KWD', symbol: 'د.ك' },
  { code: 'MXN', symbol: '$' },
  { code: 'MYR', symbol: 'RM' },
  { code: 'NGN', symbol: '₦' },
  { code: 'NOK', symbol: 'kr' },
  { code: 'NZD', symbol: '$' },
  { code: 'PHP', symbol: '₱' },
  { code: 'PKR', symbol: '₨' },
  { code: 'PLN', symbol: 'zł' },
  { code: 'QAR', symbol: '﷼' },
  { code: 'RON', symbol: 'lei' },
  { code: 'RUB', symbol: '₽' },
  { code: 'SAR', symbol: '﷼' },
  { code: 'SEK', symbol: 'kr' },
  { code: 'SGD', symbol: '$' },
  { code: 'THB', symbol: '฿' },
  { code: 'TRY', symbol: '₺' },
  { code: 'TWD', symbol: 'NT$' },
  { code: 'USD', symbol: '$' },
  { code: 'UYU', symbol: '$U' },
  { code: 'VND', symbol: '₫' },
  { code: 'ZAR', symbol: 'R' },
];

export const DEFAULT_CURRENCIES: Currency[] = ['USD', 'EUR', 'ILS'];

export const getCurrencySymbol = (currency: Currency): string => {
  const found = CURRENCIES.find(c => c.code === currency);
  return found?.symbol || '';
};

export const getCurrencyDisplay = (currency: Currency): string => {
  const symbol = getCurrencySymbol(currency);
  return `${currency} (${symbol})`;
};
